module.exports = __webpack_public_path__ + "static/media/silver.ea8c3789.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/cattributes/silver.svg
// module id = 166
// module chunks = 0